import { useMutation } from '@apollo/client';
import { useCallback, useEffect, useRef, useState } from 'react';
import { gql } from '@/modes/company/gql';

const CREATE_SETUP_INTENT = gql(`
  mutation CreateSetupIntent {
    createStripeSetupIntent {
      clientSecret
      sessionClientSecret
      phone
      email
    }
  }
`);

type SetupIntentPayload = {
  clientSecret: string;
  sessionClientSecret: string;
  phone: string | null;
  email: string | null;
};

export function useStripeSetupIntent() {
  const [createSetupIntent] = useMutation<{
    createStripeSetupIntent: SetupIntentPayload;
  }>(CREATE_SETUP_INTENT);
  const [payload, setPayload] = useState<SetupIntentPayload | null>(null);
  const hasFetchedRef = useRef(false);

  useEffect(() => {
    if (hasFetchedRef.current) return;

    hasFetchedRef.current = true;

    createSetupIntent()
      .then(({ data }) => {
        if (!data) return;
        console.log('Created setup intent', data.createStripeSetupIntent);
        setPayload(data.createStripeSetupIntent);
      })
      .catch((err) => {
        hasFetchedRef.current = false; // allow retry on failure
        console.error('Failed to create setup intent:', err);
      });
  }, [hasFetchedRef.current]);

  const reset = useCallback(() => {
    hasFetchedRef.current = false;
    setPayload(null);
  }, []);

  return {
    ...payload,
    reset,
  };
}
